import Stack from '@mui/joy/Stack';

import PhoneTopper from 'components/PhoneTopper';
import EmailSender from 'components/EmailSender';
import CalendarTools from 'components/CalendarTools';
import CenteredText from 'components/CenteredText';
import LockedFeature from 'components/LockedFeature';
import useClock from 'hooks/useClock';

const AssociatedTools = ({associated_type, associated_uuid, from_email }:
{associated_type: string, associated_uuid: string, from_email: string}) => {
    const { currentClock } = useClock();
    if(!currentClock) {
        return (
            <CenteredText level="body-xs">Clock in to access tools</CenteredText>
        );
    }

    if(currentClock.associated_type !== associated_type ||
        currentClock.associated_uuid !== associated_uuid) {
            return <CenteredText>Unable to load. <br />
                       first: {currentClock.associated_uuid} <br />
                       second: { associated_uuid }</CenteredText>;
    }

    return (
        <LockedFeature
            lockedIconName="ConnectWithoutContact"
            copy="Communication Tools">

        <Stack spacing={1}>
            <Stack
                spacing={0}
                direction="row"
                justifyContent="center"

            >
                <PhoneTopper
                    associated_type={associated_type}
                    associated_uuid={associated_uuid}
                />
                <EmailSender
                    associated_type={associated_type}
                    associated_uuid={associated_uuid}
                    from_email={from_email}
                    onSent={() => { console.log("sent"); }}
                />
            </Stack>

            <Stack>
                <CalendarTools
                    associated_type={associated_type}
                    associated_uuid={associated_uuid}
                />
                    </Stack>
            </Stack>
        </LockedFeature>

  );
}
export default AssociatedTools;
